<template>
    <div v-if="activeFilters.length" class="flex flex-wrap items-center gap-2">
        <UPopover
            v-for="f in activeFilters"
            :key="f.key.toString()"
            :popper="{ placement: 'bottom-start' }"
            :ui="{ base: 'overflow-visible focus:outline-none relative' }"
        >
            <div class="flex items-center gap-1 rounded-full bg-primary-50 hover:bg-primary-100 ring-1 ring-inset ring-primary-200 pl-2.5 pr-1 py-1 text-xs cursor-pointer">
                <span class="font-medium text-primary-700">{{ filterChipSummary(f) }}</span>
                <UButton
                    icon="i-ph-x-bold"
                    size="2xs"
                    color="primary"
                    variant="ghost"
                    :padded="false"
                    class="p-0.5"
                    @click.stop="clearFilter(f.key)"
                />
            </div>
            <template #panel>
                <div class="w-72 p-4 space-y-2">
                    <p class="text-sm font-medium text-gray-700">{{ f.label }}</p>
                    <OverlayFiltersFilterInput :filter="f" @update:filter="onUpdate" />
                </div>
            </template>
        </UPopover>

        <UButton variant="link" color="gray" size="xs" @click="clearAll">Clear all</UButton>
    </div>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'
import { filterChipSummary, isFilterActive } from '~/utils/filter-chip-summary'

const props = defineProps<{ filters: Filter[] }>()
const emit = defineEmits<{ 'update:filters': [Filter[]] }>()

const activeFilters = computed(() => props.filters.filter(isFilterActive))

function onUpdate(updated: Filter) {
    emit('update:filters', props.filters.map(f => (f.key === updated.key ? updated : f)))
}

function clearFilter(key: Filter['key']) {
    emit('update:filters', props.filters.map(f => (f.key === key ? { ...f, value: undefined, selected: undefined } : f)))
}

function clearAll() {
    emit('update:filters', props.filters.map(f => ({ ...f, value: undefined, selected: undefined })))
}
</script>
